import * as Styled from "./SeeCard.styled";
import { ChevronRight } from "react-bootstrap-icons";

type SeeCardProps = {
  width?: string;
  height?: string;
};

export function SeeCard({ width, height }: SeeCardProps) {
  return (
    <Styled.Card width={width} height={height}>
      <Styled.Text>
        <span>See All</span>
          <ChevronRight size={18} />
      </Styled.Text>
    </Styled.Card>
  );
}
